module.exports = __webpack_public_path__ + "img/person-holding-rmr-card.5e7f1d2c.png";